"use client";
import { useSettings } from "@/context/settingsContext";
import { getSettingValue } from "@/utils/utils";
import { useEffect, useState } from "react";

export default function useIsMobile(breakpoint = 992) {
  const { settings } = useSettings();
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    if (!settings) return;

    const siteAnimation = getSettingValue(settings, "site_animation");

    if (siteAnimation === "0" || siteAnimation === 0) {
      setIsMobile(true);
      return;
    }

    const check = () => setIsMobile(window.innerWidth < breakpoint);
    check();

    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [settings, breakpoint]);

  return isMobile;
}
